export default __webpack_public_path__ + "bannerWithContentOverlay.png";